import React from "react"
import { DateTime } from "luxon"
import { makeStyles } from "tss-react/mui"
import { Grid, Typography } from "@mui/material"
import { faCircle } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faRedo, faPlateUtensils, faPersonSign } from "@fortawesome/pro-light-svg-icons"
import { LocalizedEnum, LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { tailwindPalette } from "../../../../theme/tailwindPalette"
import { DailyMenu } from "../menuPlanningTypes"

const useStyles = makeStyles()((theme) => ({
    container: {
        display: "flex",
        alignItems: "center",
        flexWrap: "nowrap",
        gap: "1rem",
    },
    box: {
        display: "flex",
        gap: "0.5rem",
        alignItems: "center",
    },
    textColor: {
        color: tailwindPalette.slate[600],
    },
    icon: {
        fontSize: "1rem",
        color: "#0288D1",
    },
    counter: {
        padding: "0 0.25rem",
        borderRadius: "0.125rem",
        background: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    cellIconDivider: {
        width: "0.25rem",
        height: "0.25rem",
        color: tailwindPalette.slate[500],
        marginBottom: "1px",
    },
}))

type MenuDetailsProps = Readonly<{
    menu: DailyMenu
}>

export function MenuDetails({ menu }: MenuDetailsProps) {
    const { classes, cx } = useStyles()
    const formattedDate = DateTime.fromISO(menu.publishDate).toFormat("cccc - dd/MM")
    const signageTypesLength = menu.signageTypes?.length

    return (
        <>
            <Grid container flexDirection="column" gap="1rem" className={classes.textColor}>
                <Typography variant="body2">{formattedDate}</Typography>
                <Grid className={classes.container}>
                    {!!signageTypesLength && (
                        <Grid item className={cx(classes.box, classes.textColor)}>
                            <FontAwesomeIcon icon={faPersonSign} className={classes.icon} />
                            {menu.signageTypes.map((el, index) => (
                                <React.Fragment key={el}>
                                    <LocalizedEnum
                                        base="merchant-menu-planning-dialog-signageTypes-mode"
                                        enumValue={el}
                                    >
                                        <Typography variant="caption">{el}</Typography>
                                    </LocalizedEnum>
                                    {index < signageTypesLength - 1 && (
                                        <FontAwesomeIcon className={classes.cellIconDivider} icon={faCircle} />
                                    )}
                                </React.Fragment>
                            ))}
                        </Grid>
                    )}
                    <Grid item className={cx(classes.box, classes.textColor)}>
                        <FontAwesomeIcon icon={faPlateUtensils} className={classes.icon} />
                        <LocalizedStrict id="merchant-menu-planning-table-dishes-count">
                            <Typography variant="caption">dishes</Typography>
                        </LocalizedStrict>
                        <Grid className={classes.counter}>{menu.dishes.length}</Grid>
                    </Grid>
                    {menu.recurrence?.days.length && (
                        <Grid item className={cx(classes.box, classes.textColor)}>
                            <FontAwesomeIcon icon={faRedo} className={classes.icon} />
                            <LocalizedStrict id="merchant-menu-planning-table-recurrence">
                                <Typography variant="caption">Recurrence</Typography>
                            </LocalizedStrict>
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </>
    )
}
